import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import useFabricDetails from 'data-hooks/useFabricDetails';
import useFabricReviews from 'data-hooks/useFabricReviews';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import { GET_FABRIC_GALLERY_DATA } from '@/graphql/queries';
import SwatchesFabricDetailSidebarUI from '.';
const SwatchesFabricDetailSidebar = t0 => {
  const $ = _c(18);
  const {
    isOpen,
    onClose,
    fabricId,
    galleryType,
    mobileHideHeader: t1
  } = t0;
  const mobileHideHeader = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      w: 1800,
      h: 915
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const zoomImgProps = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      height: 300,
      width: 590
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const jbImgProps = t3;
  const {
    error,
    data: t4
  } = useFabricDetails(fabricId);
  const {
    selectedFabric
  } = t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      variables: {
        fromCache: true
      }
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const {
    data: fabricsGalleryData
  } = useSuspenseQuery(GET_FABRIC_GALLERY_DATA, t5);
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      auto: "format,compress",
      fit: "fill",
      crop: "entropy",
      h: 430,
      w: 875
    };
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const imgProps = t6;
  let t7;
  if ($[4] !== fabricsGalleryData || $[5] !== selectedFabric) {
    bb0: {
      if (!selectedFabric || !fabricsGalleryData?.getFabricGalleryData) {
        t7 = null;
        break bb0;
      }
      const itemData = fabricsGalleryData.getFabricGalleryData;
      const itemGalleryDataRaw = itemData[selectedFabric?.option_value_id];
      if (!itemGalleryDataRaw) {
        t7 = null;
        break bb0;
      }
      let itemGalleryData;
      ;
      try {
        itemGalleryData = JSON.parse(itemGalleryDataRaw);
      } catch (t8) {
        t7 = null;
        break bb0;
      }
      const {
        img_prefix: t9,
        img_suffixes: t10
      } = itemGalleryData;
      const img_prefix = t9 === undefined ? "" : t9;
      const img_suffixes = t10 === undefined ? "" : t10;
      const img_suffixesList = img_suffixes.length ? img_suffixes.split(",") : null;
      if (!img_suffixesList) {
        t7 = null;
        break bb0;
      }
      const images = [];
      for (let i = 0; i < img_suffixesList.length; i++) {
        images.push({
          url: "https://joybird2.imgix.net/fabric-swatches/t1/".concat(img_prefix, `-t1-${img_suffixesList[i]}.jpg`),
          isVideo: false,
          imgProps,
          zoomUrl: "https://joybird2.imgix.net/fabric-swatches/t1/".concat(img_prefix, `-t1-${img_suffixesList[i]}.jpg`),
          videoProps: {},
          className: "",
          zoomImgProps,
          jbImgProps
        });
      }
      t7 = images;
    }
    $[4] = fabricsGalleryData;
    $[5] = selectedFabric;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const sliderImages = t7;
  let t8;
  bb1: {
    if (!selectedFabric) {
      t8 = null;
      break bb1;
    }
    let t9;
    if ($[7] !== selectedFabric || $[8] !== sliderImages) {
      t9 = {
        ...selectedFabric,
        sliderImages
      };
      $[7] = selectedFabric;
      $[8] = sliderImages;
      $[9] = t9;
    } else {
      t9 = $[9];
    }
    t8 = t9;
  }
  const selectedFabricWithSliderImages = t8;
  const {
    data: t9
  } = useFabricReviews(fabricId);
  const {
    reviews,
    rating
  } = t9;
  if (error) {
    return null;
  }
  let t10;
  if ($[10] !== galleryType || $[11] !== isOpen || $[12] !== mobileHideHeader || $[13] !== onClose || $[14] !== rating || $[15] !== reviews || $[16] !== selectedFabricWithSliderImages) {
    t10 = <SwatchesFabricDetailSidebarUI isOpen={isOpen} onClose={onClose} selectedFabric={selectedFabricWithSliderImages} galleryType={galleryType} mobileHideHeader={mobileHideHeader} reviews={reviews} rating={rating} />;
    $[10] = galleryType;
    $[11] = isOpen;
    $[12] = mobileHideHeader;
    $[13] = onClose;
    $[14] = rating;
    $[15] = reviews;
    $[16] = selectedFabricWithSliderImages;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};
SwatchesFabricDetailSidebar.propTypes = {
  fabricId: PropTypes.number,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  galleryType: PropTypes.string,
  mobileHideHeader: PropTypes.bool
};
export default SwatchesFabricDetailSidebar;